/**
 * The default values of tooltip settings. These are set on init and
 * whenever the tooltip is closed
 *
 * @type {TooltipSettings}
 */
export var defaultTooltipContextValue = {
    x: 0,
    y: 0,
    content: null,
    isVisible: false,
};
//# sourceMappingURL=defaultTooltipContextValue.js.map